import badge from "@/assets/app-store-badge.svg";
import { APP_STORE_URL } from "@/lib/appStore";

interface Props {
  /** Rendered badge height in px. Apple's minimum for this badge is 40. */
  height?: number;
  className?: string;
}

/**
 * Apple's "Download on the App Store" badge.
 *
 * This is Apple's own artwork (Download_on_the_App_Store_Badge_US-UK_RGB_blk,
 * 119.664x40, all outlines, no live text), rendered through an <img> so it is
 * never restyled or re-typeset. It replaces a hand-drawn lookalike that set the
 * wordmark as SVG <text> in a substitute font, which Apple's identity guidelines
 * do not permit.
 *
 * Apple's requirements honoured here:
 *  - minimum height 40px, and the artwork is only ever scaled proportionally
 *  - clear space on all sides of at least 10% of the badge height, applied as
 *    padding on the link so neighbouring content can never crowd it
 *  - the badge is not recoloured, outlined, or altered
 */
export function HomeAppStoreBadge({ height = 44, className }: Props) {
  const clearSpace = Math.ceil(height * 0.1);
  const width = Math.round((height * 119.66407) / 40);

  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={{ padding: clearSpace, display: "inline-block", lineHeight: 0 }}
    >
      <img
        src={badge}
        alt="Download on the App Store"
        width={width}
        height={height}
        style={{ height, width }}
      />
    </a>
  );
}
